<div *ngIf="isPreLoading">
  <div id="commonLoaderAP">
    <div class="lds-dual-ring">
      <img src="assets/favicon.ico" alt="Affordplan">
    </div>
  </div>
</div>
<router-outlet></router-outlet>
